import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, palette, BasicTooltip, ExpandedTooltip, getUtility } from '@livable/saas-react-components';
import { Box, Button, TextField, Typography } from '@mui/material';
import { DataGrid, gridClasses, GridColumnMenu } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDelay } from 'src/utils/hooks';
// import { PropertyMenu } from './PropertyMenu';
import useStyles from './styles';
import { PropertyCheckElement } from './propertyCheckElement';
import RippleEffect from 'src/components/general/RippleEffect';
import { exportCSVFromDataGrid } from 'src/utils/exportCSV';
import { currencyFormatter } from 'src/utils/translator';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { useNavigate } from 'react-router-dom';
import { ActiveBuildingMenu } from 'src/components/property/ActiveBuildingMenu';
import { InactiveBuildingMenu } from 'src/components/property/InactiveBuildingMenu';
import { useStore } from 'src/stores';
import moment from 'moment/moment';
import { MovePropertiesModal } from '../PropertiesBatchActions/MovePropertiesModal';
export const PropertiesDataGrid = observer(_ref => {
  let searchKey = _ref.searchKey,
    selectedRows = _ref.selectedRows,
    propertiesList = _ref.propertiesList,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    triggerRefresh = _ref.triggerRefresh,
    isSelectAllPropertiesEnabled = _ref.isSelectAllPropertiesEnabled,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal = _ref.handleShowAutoBillingBatchModalModal,
    openPropertyDetails = _ref.openPropertyDetails;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const store = useStore();
  const _useState = useState({
      pageSize: 25,
      page: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    paginationModel = _useState2[0],
    setPaginationModel = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    sortModel = _useState4[0],
    setSortModel = _useState4[1];
  const handleSetSortModel = async data => {
    if (!data.length) {
      data = [{
        field: 'Unitname',
        sort: 'asc'
      }];
    }
    setSortModel(data);
  };
  const handleSetPaginationModel = async data => {
    setPaginationModel(data);
  };
  useDelay(() => {}, [searchKey], 1000);
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const Cell = _ref2 => {
    let field = _ref2.field,
      icon = _ref2.icon,
      row = _ref2.row,
      cellType = _ref2.cellType,
      rowIndex = _ref2.rowIndex;
    const getFieldWrapper = type => {
      if (type === 'propertyAddress') {
        return /*#__PURE__*/React.createElement(ExpandedTooltip, {
          title: row.dashboard.propertyAddress,
          placement: "top"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        }, field));
      } else if (type === 'portfolioName') {
        var _row$propertyPortfoli;
        return /*#__PURE__*/React.createElement(ExpandedTooltip, {
          title: (_row$propertyPortfoli = row.propertyPortfolioInfo) === null || _row$propertyPortfoli === void 0 ? void 0 : _row$propertyPortfoli.name,
          placement: "top"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          },
          onClick: event => {
            event.preventDefault();
            event.stopPropagation();
            console.log('open portfolio move modal');
            // store.portfoliosMultiActionStore.deselectSelectedItem(item.dashboard.propertyId)
            // store.portfoliosMultiActionStore.setSelectedItem(item.dashboard)
          }
        }, field));
      } else if (type === 'property-status') {
        return row.dashboard.propertyStatus === 'Active' ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
          title: "Launched on ".concat(moment(row.dashboard.enrollmentDate).format('MM/DD/YYYY')),
          type: row.dashboard.propertyStatus === 'Active' ? 'success' : 'info',
          placement: "top"
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: row.dashboard.propertyStatus === 'Active' ? 'success' : 'info'
        }, row.dashboard.propertyStatus)) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: row.dashboard.propertyStatus === 'Active' ? 'success' : 'info'
        }, row.dashboard.propertyStatus);
      } else if (cellType === 'utilities') {
        var _row$dashboard$utilit;
        return !!((_row$dashboard$utilit = row.dashboard.utilityIds) !== null && _row$dashboard$utilit !== void 0 && _row$dashboard$utilit.length) ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
          type: "utilities-success",
          title: /*#__PURE__*/React.createElement("div", {
            className: classes.utilitiesTooltip
          }, /*#__PURE__*/React.createElement("div", {
            className: "tooltip-header"
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "h6"
          }, t('portfolios_properties_page.property_utilities'))), /*#__PURE__*/React.createElement("div", {
            className: "tooltip-content"
          }, row.dashboard.utilityIds.map(utilId => {
            var _store$homeDashboardS, _store$homeDashboardS2;
            return /*#__PURE__*/React.createElement("div", {
              key: utilId,
              className: classes.utilitiesTooltipItem
            }, getUtility((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.getUtilityInfoById(utilId)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.utilityTypeName).icon(), /*#__PURE__*/React.createElement(Typography, {
              variant: "h5"
            }, (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.getUtilityInfoById(utilId)) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.utilityTypeName));
          }))),
          placement: "top"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            width: '100%'
          }
        }, field)) : /*#__PURE__*/React.createElement("span", {
          style: {
            width: '100%'
          }
        }, field);
      } else if (cellType === 'autoBillingStatus') {
        return /*#__PURE__*/React.createElement(Typography, {
          className: classes.autoBillingStatus,
          variant: "formHint",
          state: rowIndex % 2 === 0 ? 'success' : rowIndex % 3 === 0 ? 'inactive' : 'error',
          onClick: event => {
            event.stopPropagation();
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            rowIndex % 2 !== 0 && handleShowAutoBillingBatchModalModal(true, row, 'test portfolio data');
          }
        }, rowIndex % 2 !== 0 ? /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "warning",
          type: "paper-dollar"
        }) : rowIndex % 3 === 0 ? /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "lightGrey",
          type: "paper-dollar"
        }) : /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "error",
          type: "paper-dollar"
        }));
      } else {
        return field;
      }
    };
    return /*#__PURE__*/React.createElement(RippleEffect, {
      className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
    }, icon ? /*#__PURE__*/React.createElement(Icon, {
      className: classes.cellContentIcon,
      state: icon === 'building' ? 'success' : 'info',
      type: icon === 'building' ? 'building' : 'edit'
    }) : null, getFieldWrapper(cellType));
  };
  const AccessCell = observer(_ref3 => {
    var _params$row, _params$row2;
    let params = _ref3.params;
    const handleOpenTeamMangeModal = event => {
      event.stopPropagation();
      event.preventDefault();
      if (store.account.userProfile.isUserPropertyManagerRegular) return;
      handleShowManageAccessModal(true, params.row.dashboard, null);
    };
    const accessMembers = [...new Map([...(params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 || (_params$row = _params$row.dashboard) === null || _params$row === void 0 ? void 0 : _params$row.accessResponses), ...(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 || (_params$row2 = _params$row2.propertyPortfolioInfo) === null || _params$row2 === void 0 ? void 0 : _params$row2.accessResponses)].map(i => [i.accountId, i])).values()];
    if ((accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 0 && (accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) <= 3) {
      return /*#__PURE__*/React.createElement(RippleEffect, {
        className: 'cellContent'
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.avatarsBlock,
        onClick: handleOpenTeamMangeModal
      }, accessMembers.map(item => {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.avatar
        }, /*#__PURE__*/React.createElement(BasicTooltip, {
          title: "".concat(item.firstName, " ").concat(item.lastName),
          placement: "top"
        }, item.firstName.toUpperCase().charAt(0)));
      }), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.avatar, " ").concat(classes.avatarAddPlusBlock)
      }, "+")));
    } else if ((accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 0 && (accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 3) {
      const avatars = accessMembers;
      const spliceRes = avatars.splice(0, 3);
      return /*#__PURE__*/React.createElement(RippleEffect, {
        className: 'cellContent'
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.avatarsBlock,
        onClick: handleOpenTeamMangeModal
      }, spliceRes.map(item => {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.avatar
        }, ' ', /*#__PURE__*/React.createElement(BasicTooltip, {
          title: "".concat(item.firstName, " ").concat(item.lastName),
          placement: "top"
        }, item.firstName.toUpperCase().charAt(0)));
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.avatar, " ").concat(classes.avatarAddPlusBlock)
      }, "+", avatars.length)));
    } else {
      if (store.account.userProfile.isUserPropertyManagerRegular) return null;
      return /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "small",
        onClick: handleOpenTeamMangeModal,
        'custom-attribute': '675-new-billing-module'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "user-add"
      }));
    }
  });
  const handleCellClick = params => {
    if (['autoBillingStatus', 'actions', 'select', 'access'].includes(params.field)) return;
    if (params.field === 'propertyAddress') {
      if (params.row.dashboard.propertyStatus === PROPERTY_STATUS_ENUM.Inactive) {
        navigate("/new_property?not_completed_id=".concat(params.row.dashboard.propertyId));
      } else {
        console.log('handleCellClick', params);
        openPropertyDetails(params.row.id);
      }
    }
  };
  const columns = [{
    field: 'select',
    align: 'center',
    width: 70,
    sortable: false,
    renderCell: params => {
      var _params$row3;
      return /*#__PURE__*/React.createElement(PropertyCheckElement, {
        data: params.row,
        propertyId: params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.id,
        onSelect: item => store.portfoliosMultiActionStore.isSelected(params.row.dashboard.propertyId) ? store.portfoliosMultiActionStore.deselectSelectedItem(item.dashboard.propertyId) : store.portfoliosMultiActionStore.setSelectedItem(_objectSpread(_objectSpread({}, item.dashboard), {}, {
          currentPortfolioId: item.propertyPortfolioInfo.id
        })),
        isHeader: false
      });
    },
    renderHeader: () => /*#__PURE__*/React.createElement(PropertyCheckElement, {
      data: columns,
      propertyId: 'select-all',
      onSelect: () => propertiesList.reduce((acc, item) => {
        if (acc) {
          if (store.portfoliosMultiActionStore.isSelected(item.id)) {
            return acc;
          } else return false;
        } else return false;
      }, true) ? store.portfoliosMultiActionStore.deselectAll(propertiesList.map(i => i.dashboard)) : store.portfoliosMultiActionStore.selectAll(propertiesList.map(i => i.dashboard)),
      isHeader: true,
      isHeaderChecked: propertiesList.map(i => i === null || i === void 0 ? void 0 : i.dashboard).reduce((acc, item) => {
        if (acc) {
          if (store.portfoliosMultiActionStore.isSelected(item === null || item === void 0 ? void 0 : item.propertyId)) {
            return acc;
          } else return false;
        } else return false;
      }, true)
    })
  }, {
    field: 'propertyAddress',
    align: 'left',
    headerName: t('Property'),
    isExportable: true,
    minWidth: 250,
    maxWidth: 1500,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      cellType: 'propertyAddress',
      field: params.row.dashboard.propertyAddress,
      icon: params.row.dashboard.propertyStatus === 'Active' ? 'building' : 'edit',
      row: params.row
    }),
    renderHeader: () => renderHeader('Property'),
    flex: 1
  }, {
    field: 'propertyStatus',
    width: 100,
    headerAlign: 'right',
    headerName: t('Status'),
    isExportable: true,
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.dashboard.propertyStatus,
      row: params.row,
      cellType: 'property-status'
    }),
    renderHeader: () => renderHeader('Status'),
    valueGetter: params => params.row.dashboard.propertyStatus
  }, {
    field: 'unitsTotal',
    width: 75,
    headerAlign: 'left',
    headerName: t('Total units'),
    isExportable: true,
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: "".concat(params.row.dashboard.unitsEnrolled, "/").concat(params.row.dashboard.unitsTotal),
      row: params.row
    }),
    renderHeader: () => renderHeader('Total units', true),
    valueGetter: params => "".concat(params.row.dashboard.unitsEnrolled, " out of ").concat(params.row.dashboard.unitsTotal)
  }, {
    field: 'utilities',
    width: 75,
    headerAlign: 'right',
    headerName: t('Utilities'),
    isExportable: true,
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.dashboard.utilityCount,
      cellType: 'utilities',
      row: params.row
    }),
    renderHeader: () => renderHeader('Utilities', true),
    valueGetter: params => params.row.dashboard.utilityCount
  }, {
    field: 'accountsReceivable',
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.dashboard.accountsReceivable ? currencyFormatter(Number(params.row.dashboard.accountsReceivable)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader('Account Receivable', true),
    width: 115
  }, {
    field: 'payoutToDate',
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.dashboard.distributionToDate ? currencyFormatter(Number(params.row.dashboard.distributionToDate)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: 'to date'
    }), true),
    width: 115
  }, {
    field: 'july',
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.dashboard.distributionForCurrentMonth ? currencyFormatter(Number(params.row.dashboard.distributionForCurrentMonth)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().format('MMMM YY')
    }), true),
    width: 115
  }, {
    field: 'august',
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.dashboard.distributionForNextMonth ? currencyFormatter(Number(params.row.dashboard.distributionForNextMonth)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().add(1, 'month').format('MMMM YY')
    }), true),
    width: 115
  },
  // {
  //   field: 'autoBillingStatus',
  //   headerAlign: 'left',
  //   sortable: false,
  //   renderCell: params => (
  //     <Cell
  //       field={!params.row?.autoBillingStatus}
  //       row={params.row}
  //       cellType={'autoBillingStatus'}
  //       rowIndex={params.api.getAllRowIds().indexOf(params.id) + 1}
  //     />
  //   ),
  //   renderHeader: () => renderHeader('Auto-billing', true),
  //   width: 105,
  // },
  {
    field: 'access',
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(AccessCell, {
      params: params
    }),
    renderHeader: () => renderHeader('Access', true),
    width: 115
  }, {
    field: 'actions',
    width: 130,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    filterable: false,
    hideable: false,
    renderCell: params => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, params.row.dashboard.propertyStatus !== PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActiveBuildingMenu, {
      id: params.row.dashboard.propertyId,
      menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
        type: "dotdotdot"
      }),
      handleShowEnrollModal: () => {
        var _params$row$propertyP;
        return handleShowEnrollModal(true, {
          portfolioId: (_params$row$propertyP = params.row.propertyPortfolioInfo) === null || _params$row$propertyP === void 0 ? void 0 : _params$row$propertyP.id,
          propertyId: params.row.dashboard.propertyId,
          enablePortfolioSelect: false,
          enablePropertySelect: false
        });
      },
      openPropertyDetails: openPropertyDetails,
      handleShowManageAccessModal: () => handleShowManageAccessModal(true, params.row.id, null),
      customProcessUtilityBills: () => {
        store.homeDashboardStore.selectActivePropertyId(params.row.dashboard.propertyId);
      }
    })), params.row.dashboard.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: t('dashboard_page.continue_adding_details'),
      placement: "top",
      hideOnMobile: true
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: () => navigate("/new_property?not_completed_id=".concat(params.row.dashboard.propertyId)),
      'custom-attribute': '677-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }))), /*#__PURE__*/React.createElement(InactiveBuildingMenu, {
      id: params.row.dashboard.propertyId,
      menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
        type: "dotdotdot"
      }),
      deletePropertyCallBackAction: () => {
        triggerRefresh();
      }
    })))),
    renderHeader: () => /*#__PURE__*/React.createElement("div", {
      className: classes.toolboxWrapperHeader
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      type: "button",
      'custom-attribute': '678-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    })))
  }];
  if (store.company.companyFeatureStore.isAppfolio) {
    columns.splice(5, 4);
    // columns.splice(6, 4);
    // columns.splice(5, 1);
  }

  // Note: needed portfolio name on all properties view
  if (isSelectAllPropertiesEnabled) {
    columns.splice(2, 0, {
      field: 'portfolioName',
      headerName: t('Portfolio name'),
      isExportable: true,
      minWidth: 150,
      maxWidth: 450,
      align: 'left',
      renderCell: params => {
        var _params$row$propertyP2;
        return /*#__PURE__*/React.createElement(Cell, {
          cellType: 'portfolioName',
          field: (_params$row$propertyP2 = params.row.propertyPortfolioInfo) === null || _params$row$propertyP2 === void 0 ? void 0 : _params$row$propertyP2.name,
          row: params.row
        });
      },
      renderHeader: () => renderHeader('Portfolio name'),
      flex: 1,
      valueGetter: params => {
        var _params$row$propertyP3;
        return (_params$row$propertyP3 = params.row.propertyPortfolioInfo) === null || _params$row$propertyP3 === void 0 ? void 0 : _params$row$propertyP3.name;
      }
    });
  }
  if (!store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
    const selectColumnIndex = columns.findIndex(col => col.field === 'select');
    if (selectColumnIndex !== -1) {
      columns.splice(selectColumnIndex, 1);
    }
    const accessColumnIndex = columns.findIndex(col => col.field === 'access');
    if (accessColumnIndex !== -1) {
      columns.splice(accessColumnIndex, 1);
    }
  }
  const handleDownloadCsv = () => {
    exportCSVFromDataGrid({
      columns,
      name: 'properties.csv',
      rows: propertiesList
    });
  };
  const CustomColumnMenu = props => {
    return /*#__PURE__*/React.createElement(GridColumnMenu, _extends({}, props, {
      slots: {
        columnMenuUserItem: () => /*#__PURE__*/React.createElement("div", {
          className: classes.exportCSV
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: handleDownloadCsv,
          size: "small",
          variant: "contained"
        }, "Export CSV"))
      },
      slotProps: {
        columnMenuUserItem: {
          displayOrder: 15
        }
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.tableContainer, " ").concat(!!store.portfoliosMultiActionStore.selectedItems.length ? classes.multiselectEnabled : '')
  }, /*#__PURE__*/React.createElement(Box, {
    className: "".concat(classes.boxContainer, " ").concat(!!store.portfoliosMultiActionStore.selectedItems.length ? 'multiselectEnabled' : ''),
    sx: {
      [".".concat(gridClasses.cell, ".active")]: {
        color: palette.success.main
      },
      [".".concat(gridClasses.cell, ".inactive")]: {
        color: palette.info.main
      }
    }
  }, /*#__PURE__*/React.createElement(DataGrid, {
    className: classes.grid,
    getRowId: row => {
      var _row$propertyPortfoli2;
      return "".concat(row === null || row === void 0 ? void 0 : row.id, "-").concat(row === null || row === void 0 || (_row$propertyPortfoli2 = row.propertyPortfolioInfo) === null || _row$propertyPortfoli2 === void 0 ? void 0 : _row$propertyPortfoli2.id);
    },
    columns: columns,
    onCellClick: handleCellClick,
    getCellClassName: params => {
      if (params.field === 'status') return params.row.dashboard.status === 'Active' ? 'active' : 'inactive';
    },
    initialState: {
      sorting: {
        sortModel: [
        // NOTE: disabling undesired sorting fields
        {
          field: 'enrolled',
          sortable: false
        }]
      }
    },
    slots: {
      columnMenu: CustomColumnMenu,
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: properties => /*#__PURE__*/React.createElement(Button, _extends({}, properties, {
        variant: "actionButton",
        'custom-attribute': '679-new-billing-module'
      })),
      BaseTextField: properties => /*#__PURE__*/React.createElement(TextField, _extends({}, properties, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 78,
    rowHeight: 60,
    rows: propertiesList,
    rowSelectionModel: selectedRows,
    onSortModelChange: model => handleSetSortModel(model),
    onPaginationModelChange: model => handleSetPaginationModel(model),
    paginationModel: paginationModel,
    sortModel: sortModel,
    loading: store.portfolios.getPortfoliosDashboardAsync.inProgress
  })), /*#__PURE__*/React.createElement(MovePropertiesModal, {
    key: 'PropertiesListView-MovePropertiesModal',
    customTrigger: null,
    triggerRefresh: triggerRefresh
  }));
});